
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src1738611268/src/vl-app/pages/wellbeinghub.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import WellbeingHub from './login';


export const Route = createFileRoute('/wellbeinghub')({ component: WellbeingHub });
